







































import { Form, FormElement } from '@/models/Form';
import { BAlert, BSpinner } from 'bootstrap-vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import ModalContactDetails from '@/components/modals/ModalContactDetails.vue';
import CardIntro from '@/components/CardIntro.vue';
import ElementStaticText from '@/components/ElementStaticText.vue';
import ElementInputNumber from '@/components/ElementInputNumber.vue';
import ElementInputOptions from '@/components/ElementInputOptions.vue';
import ElementInputMultiRange from '@/components/ElementInputMultiRange.vue';
import ElementInputText from '@/components/ElementInputText.vue';
import BaseReport from '@/components/BaseReport.vue';
import PreviewTools from '@/components/PreviewTools.vue';

@Component({
    name: 'EntryView',
    components: {
        'b-alert': BAlert,
        'b-spinner': BSpinner,
        'element-intro': CardIntro,
        'modal-contact-details': ModalContactDetails,
        'static-text': ElementStaticText,
        'input-number': ElementInputNumber,
        'input-options': ElementInputOptions,
        'input-multirange': ElementInputMultiRange,
        'input-text': ElementInputText,
        'base-report': BaseReport,
        'preview-tools': PreviewTools,
    },
    computed: mapGetters(['loading', 'form', 'accessCode', 'elements', 'answers', 'errors', 'report', 'points']),
})
export default class EntryView extends Vue {
    accessCode!: string;
    form!: Form;
    errors!: string[];
    answers!: { [elementId: number]: any };
    elements!: FormElement[];
    formId!: number;

    get current() {
        const index = this.elements.length - 1;
        return this.elements[index];
    }

    async created() {
        const formId = parseInt(this.$router.currentRoute.params.form, 10);
        const accessCode = this.$router.currentRoute.params.accessCode;

        if (!formId) {
            return this.$store.commit('setLoading', false);
        }

        if (formId && !accessCode) {
            await this.$store.dispatch('getForm', formId);
        }

        if (formId && accessCode) {
            this.$store.commit('setAccessCode', accessCode);
            this.$store.commit('initStorage', { formId, accessCode });

            await this.$store.dispatch('getForm', formId);

            if (Object.values(this.answers).length) {
                await this.$store.dispatch('submit');
            }
        }
    }

    async submit(answer: any) {
        if (!this.errors.length) {
            this.$store.commit('addAnswer', { elementId: this.current.id, answer });
            await this.$store.dispatch('submit');
        }
    }

    start() {
        this.$store.commit('setLoading', true);
        setTimeout(async () => {
            if (!this.accessCode) {
                this.$bvModal.show('modalContactDetails');
            } else {
                await this.$store.dispatch('submit');
            }
            this.$store.commit('setLoading', false);
        }, 400);
    }
}
